import React from 'react';
import { Link } from 'react-router';

const Header = () => (
  <header>
    <div className="poa-top-header">
      <div className="inner">
        {/* <Link className="un-brand" to="www.un.org"><div className="un-logo"></div></Link> */}
        <a target="_blank" className="un-brand" rel="noopener noreferrer" href="https://www.un.org">UN</a>
        <a target="_blank" className="un-brand" rel="noopener noreferrer" href="https://www.un.org/disarmament">UNODA</a>
        <a target="_blank" className="un-brand" rel="noopener noreferrer" href="/">Related UN databases</a>
        <a target="_blank" className="un-brand" rel="noopener noreferrer" href="https://poa.un-arm.org/login">Login</a>

      </div>
    </div>
    <div className="poa-brand-header" style = { { padding: '15px 20px 20px 30px'} } >
      <div className="inner">
        <Link activeClassName="active" to="/">
          <div className="poa-logo" />{' '}
          {/* TODO: This hold a background image... For screenreaders have real text title hiddenly available not just image */}
        </Link>
        <div className="poa-subtitle">
          <span>
            Programme of Action<br />on small arms and light weapons
          </span>
        </div>
      </div>
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js